import { render, staticRenderFns } from "./shopRecycle.vue?vue&type=template&id=b95e39b4&scoped=true"
import script from "./shopRecycle.vue?vue&type=script&lang=js"
export * from "./shopRecycle.vue?vue&type=script&lang=js"
import style0 from "./shopRecycle.vue?vue&type=style&index=0&id=b95e39b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95e39b4",
  null
  
)

export default component.exports